import { API_BASE_URL, HEADERS_WITH_TOKEN } from 'services/api/BaseUrl'

/*export const getAll = () =>
  fetch(
    `${API_BASE_URL}/menu-design`,
    {
      method: 'GET',
      headers: HEADERS_WITH_TOKEN(localStorage.getItem('mqadtk'))
    }
  )
    .then(res => res.json())*/

export const getAll = async () => {
  const usr = JSON.parse(localStorage.getItem('mqadusr'))
  const bo = JSON.parse(localStorage.getItem('mqBO'))

  const res = await fetch(
    `${API_BASE_URL}/menu-design?cmp=${usr.company._id}&bo=${bo._id}`,
    {
      method: 'GET',
      headers: HEADERS_WITH_TOKEN(localStorage.getItem('mqadtk'))
    }
  )
  return await res.json()
}

export const updateStyle = async (data) => {
  const { id, params } = data
  const res = await fetch(
    `${API_BASE_URL}/menu-design/update-style/${id}`,
    {
      method: 'POST',
      headers: HEADERS_WITH_TOKEN(localStorage.getItem('mqadtk')),
      body: JSON.stringify(params)
    }
  )
  return await res.json()
}